import { Link } from "react-router-dom";
import { useTenant } from "tenant";
import { Container } from "layout";

/** Company name, logo and short description at the top of every page. */
const CompanyHeader = () => {
  const { company } = useTenant();
  const name = company.name || "Careers";

  return (
    <header className="border-b border-orange-100 bg-white">
      <Container>
        <div className="flex items-center gap-4 py-4">
          <Link to="/" className="flex items-center gap-3">
            {company.logoUrl ? (
              <img
                src={company.logoUrl}
                alt={`${name} logo`}
                className="h-10 w-10 rounded object-contain"
              />
            ) : (
              <span
                aria-hidden="true"
                className="flex h-10 w-10 items-center justify-center rounded bg-orange-100 text-lg font-semibold text-orange-600"
              >
                {name.charAt(0).toUpperCase()}
              </span>
            )}
            <span className="text-lg font-semibold text-gray-900">{name}</span>
          </Link>
        </div>
      </Container>
    </header>
  );
};

export default CompanyHeader;
